export default "__VITE_ASSET__CsG2DC$s__"